import React, { useState } from "react";
import "./PlanTable.scss";

const PlanTable = ({ bundles, translation, sendSelectedPlan }) => {
  const [selectedBundle, setSelectedBundle] = useState(null);
  const handleRadioChange = (bundle) => {
    setSelectedBundle(bundle);
    sendSelectedPlan(bundle);
  };

  translation = {
    bundles: "Bundles",
    resources: "Resources",
    bonusOnAM: "Bonus on purchase via Airtel Money",
    dailyBonus: "Daily Bonus",
    validity: "Bundle Validity",
    price: "Price",
    dailyBonusCondition: "(applicable once data resources are exhausted)",
    priceMessage: "(Tax Incl.)",
  };

  return (
    <div className="buybundle_table-x">
      <div className="buybundle_table">
        {!!bundles?.length && (
          <div className="buybundle-head">
            <div className="buybundle_cell"></div>
            <div className="buybundle_cell">Bundles</div>
            <div className="buybundle_cell">Resources</div>
            <div className="buybundle_cell">Bundle Validity</div>
            <div className="buybundle_cell">
              Price
            </div>
          </div>
        )}
        {!!bundles?.length &&
          bundles.map((bundle) => (
            <div
              className="buybundle_row"
              onClick={() => handleRadioChange(bundle)}
              key={bundle.name}
            >
              <div className="buybundle_cell">
                <label className="bundle-radio">
                  <input
                    type="radio"
                    name="bundle"
                    className="bundle_desc"
                    value={bundle.name}
                    checked={selectedBundle?.description === bundle.description}
                    onChange={() => handleRadioChange(bundle)}
                  />
                  <span className="bundle-radio-checkmark"></span>
                </label>
              </div>
              <div className="buybundle_cell">{bundle.description}</div>
              <div className="buybundle_cell">
                <div className="bundle_dl">
                  {bundle.data} {bundle.dataUnit}
                </div>
              </div>
              <div className="buybundle_cell">
                <div className="bundle_dl">
                  {bundle.validity} {bundle.validityUnit}
                </div>
              </div>
              <div className="buybundle_cell">
                <div className="bundle_currency">
                  <span>{bundle.currency} { }</span>
                  {bundle.amount}
                </div>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default PlanTable;